import React from 'react';
import Collapsible from 'react-collapsible';
import * as label from '../constants';
import { useSelector, useDispatch } from 'react-redux'
import { updateIsOpen } from '../actions/ui';

const CollapsibleItem = (props) => {
  const {
    id="",
    children,
    isSmall=false,
    isForm=true,
    titleSection="",
    descriptionSection="",
  } = props


  const isFormOpen = useSelector((state) => state.ui.isFormOpen);
  const dispatch = useDispatch();

  const handleToggle = (isOpen=false) => {
    if (id==='' || isFormOpen[id]===isOpen) return;
    dispatch(updateIsOpen(id,isOpen));
  }


  let title = titleSection!=='' ? titleSection : label.sectionTitles[id];
  let description = descriptionSection!=='' ? descriptionSection : label.sectionDescriptions[id];

  const renderTrigger = () => {
    let classTrigger = `collapsible-header ${isSmall ? 'is-small' : ''}`;
    return (
      <div className={classTrigger}><h5 className={classTrigger}>{title}</h5></div>
    )
  }

  return (
    <Collapsible
      trigger={renderTrigger()}
      className={isSmall ? 'is-small' : ''}
      onOpen={()=>handleToggle(true)}
      onClose={()=>handleToggle()}
      overflowWhenOpen="visible"
    >
      <p className={`body-copy mb-40 body-description ${isSmall ? 'is-small mt-32' : ''}`}>{description}</p>
      <div className={`collapsible-children ${isForm ? 'is-form' : ''} ${isSmall ? 'is-small' : ''}`}>
        {children}
      </div>
    </Collapsible>
  )
}

export default CollapsibleItem;

